import React, { Component } from 'react';
import { Icon, Radio } from 'antd';
import { Avatar, Box, Flex, Group, Stack, Text, ThemeIcon } from '@good/ui/core';
import _ from 'lodash';
import WorkerStatusTagV2, { WorkerStatusTooltip } from 'common-components/tags/WorkerStatusTagV2';
import { CustomerSupportWorkerPreference, ShiftSlotStatus } from 'utilities/enum-utils';
import { Info } from '@good/icons';

class FoundWorkerRow extends Component<{
  worker: any;
  isSearch: boolean;
  selectWorker: (selectedWorker) => void;
  isSelected: boolean;
}> {
  render() {
    const { worker, isSelected } = this.props;

    const workerPreferenceBlocked = worker.preference === CustomerSupportWorkerPreference.BLOCKED;
    const workerPreferencePreferred = worker.preference === CustomerSupportWorkerPreference.PREFERRED;
    const isDisabled = worker.availability === 'NOT_AVAILABLE' || worker.availability === ShiftSlotStatus.ON_LEAVE;
    const isShowPreviouslyUsed = worker.previouslyUsed && !workerPreferenceBlocked;
    const isShowSkillMatched = worker.skillMatched && !workerPreferenceBlocked;
    return (
      <>
        <tr
          className={`bordered-bottom cursor-pointer ${isSelected && 'bg-blue-action-lightest'} ${
            workerPreferenceBlocked || (isDisabled && `cursor-not-allowed`)
          } `}
          onClick={() => (workerPreferenceBlocked || isDisabled ? null : this.props.selectWorker(worker))}
        >
          <td className='text-align-center pl-small' style={{ padding: '8px 0' }}>
            <Radio key={worker.supportWorkerId} checked={isSelected} disabled={workerPreferenceBlocked || isDisabled} />
          </td>
          <td style={{ width: 32 }}>
            <Avatar
              size='sm'
              radius='md'
              src={worker.attachmentUrl}
              style={{ opacity: workerPreferenceBlocked || isDisabled ? 0.5 : 1 }}
            />
          </td>
          <td style={{ width: 150 }}>
            <Stack gap={0} py={12}>
              <Box>
                <Text fw={600} fz='sm' style={{ opacity: workerPreferenceBlocked || isDisabled ? 0.5 : 1 }} lh={1.3}>
                  {worker.firstName} {worker.lastName}
                </Text>
                {workerPreferencePreferred && (
                  <WorkerStatusTooltip content='This worker is preferred by the customer'>
                    <Icon type='star' className='text-color-warning-orange ml-x-small' theme='filled' />
                  </WorkerStatusTooltip>
                )}
                {(isShowPreviouslyUsed || isShowSkillMatched) && (
                  <div style={{ opacity: workerPreferenceBlocked || isDisabled ? 0.5 : 1 }} className='flex-row'>
                    <Stack gap={4} c='dimmed'>
                      {isShowPreviouslyUsed && (
                        <WorkerStatusTooltip
                          title='Previously used'
                          content='Team member has previously worked with this customer'
                        >
                          <Group wrap='nowrap' gap={4}>
                            <ThemeIcon
                              fz={10}
                              size={10}
                              w={10}
                              h={10}
                              variant='transparent'
                              c='var(--mantine-color-text)'
                            >
                              <Info />
                            </ThemeIcon>
                            <Text fz='xs' lh={1} fw={500}>
                              Previously used
                            </Text>
                          </Group>
                        </WorkerStatusTooltip>
                      )}
                      {isShowSkillMatched && (
                        <WorkerStatusTooltip
                          title='Skill match'
                          content='Team member’s skills match the customer’s care needs'
                        >
                          <Group wrap='nowrap' gap={4}>
                            <ThemeIcon
                              fz={10}
                              size={10}
                              w={10}
                              h={10}
                              variant='transparent'
                              c='var(--mantine-color-text)'
                            >
                              <Info />
                            </ThemeIcon>
                            <Text fz='xs' lh={1}>
                              Skill match
                            </Text>
                          </Group>
                        </WorkerStatusTooltip>
                      )}
                    </Stack>
                  </div>
                )}
              </Box>
            </Stack>
          </td>
          <td>
            <Flex justify='end' w='100%' pr='sm'>
              <WorkerStatusTagV2
                shiftSlotStatus={worker.availability}
                preference={worker.preference}
                icon='info-circle'
                size='xsmall'
              />
            </Flex>
          </td>
        </tr>
      </>
    );
  }
}

export default FoundWorkerRow;
